import { render, staticRenderFns } from "./TaskNotifyMeList.vue?vue&type=template&id=2b9be046&scoped=true&"
import script from "./TaskNotifyMeList.vue?vue&type=script&lang=js&"
export * from "./TaskNotifyMeList.vue?vue&type=script&lang=js&"
import style0 from "./TaskNotifyMeList.vue?vue&type=style&index=0&id=2b9be046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9be046",
  null
  
)

export default component.exports